import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const conferenceApi = generateNomenApi<{ conferenceName: string }>(`/conferences`); // TODO SEPARATE conference from nomen

export const conferenceOptions = generateNomenOptions('conference', conferenceApi);
